<template>
    <div class="footer">
        <div class="footer_top">
            <div class="footer_left">
                <div class="tag_box">
                    <!-- <div class="tag_item">首页</div> -->
                    <router-link to="/homeCenter/notice" class="tag_item">首页</router-link>
                    <router-link to="/homeCenter/resultsQuery" class="tag_item">成绩查询</router-link>
                    <router-link to="/homeCenter/signUp" class="tag_item">机构报名</router-link>
                    <router-link to="/homeCenter/signUpList" class="tag_item">报名记录</router-link>
                    <router-link to="/homeCenter/myNotice" class="tag_item">我的通知</router-link>
                    <router-link to="/homeCenter/userSetting" class="tag_item">个人设置</router-link>
                </div>
                <div class="des_box">
                    <div>{{baseInfo.copyrightNotice}}</div>
                    <div style="cursor: pointer" @click="linkTo">{{baseInfo.recordNumber}}</div>
                </div>
            </div>
            <div class="footer_right">
                <img src="@/assets/icon_phone.png" class="icon_phone"/>
                <div class="mb_6">全国服务热线</div>
                <div class="mb_6">{{baseInfo.phone}}</div>
                <div>服务时间：{{baseInfo.startTime}}-{{baseInfo.endTime}}</div>
            </div>
        </div>
        <div class="footer_bottom">
            <!-- <span class="">版权所有：{{baseInfo.copyrightNotice}}</span> -->
			<span class="" @click="toIcp">蜀ICP备2025124903号-2</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "AppFooter",
    props: {
        baseInfo: Object
    },
    data() {
        return {}
    },
    methods: {
        linkTo() {
            if (this.baseInfo.link) {
                window.location.href = this.baseInfo.link
            }
        },
		toIcp(){
			 window.location.href = 'https://beian.miit.gov.cn'		
		}
    }
}

</script>

<style scoped lang="scss">
.footer_top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 90px 360px 98px 432px;
    height: 372px;
    background-color: #022867;
    color: #fff;
}

.footer_left {
    flex: 1;

    .tag_box {
        display: flex;
        align-items: center;
        font-size: 20px;

        .tag_item {
            font-size: 20px;
            font-weight: 600;
            margin-right: 80px;
            cursor: pointer;
        }
    }

    .des_box {
        margin-top: 40px;
        font-size: 18px;

        > div {
            margin-bottom: 12px;
        }
    }
}

.footer_right {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 184px;
    height: 184px;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.1);
    font-size: 10px;

    .icon_phone {
        width: 41px;
        height: 38px;
        margin-bottom: 16px;
    }
}

.footer_bottom {
    height: 80px;
    background-color: #012154;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #fff;
}
</style>./Footer.vue
